import * as React from "react";
import { FunctionComponent, useRef } from "react";
import { WindowState, PricesWidgetSettings, WidgetInstance } from "../types";
import HgvWidgetContainer from "./HgvWidgetContainer";

interface Props {
  settings: PricesWidgetSettings;
}

const PricesWidget: FunctionComponent<Props> = ({ settings }) => {
  const ref = useRef<HTMLDivElement>(null);
  const widgetInstanceRef = useRef<WidgetInstance>();

  const initWidget = () => {
    if (!ref.current) return;

    const { BookingSüdtirol } = (window as unknown) as WindowState;
    widgetInstanceRef.current = new BookingSüdtirol.Widgets.Prices(
      ref.current,
      settings
    );
    widgetInstanceRef.current.render();
  };

  return (
    <HgvWidgetContainer
      widgetInstance={widgetInstanceRef.current}
      initWidget={initWidget}
      settings={settings}
      enableLazyload={true}
    >
      <div className="PricesWidget__Container" ref={ref} />
    </HgvWidgetContainer>
  );
};

export default PricesWidget;
